import React from 'react';

export default function BusinessOverview({ title, subtitle }) {
  return <div></div>;
}
